import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ComponentModule } from 'src/app/user/component/component.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule } from '@angular/forms';
import { WebappCategoriesC001UserComponent } from './webapp-categories-c001-user/webapp-categories-c001-user.component';
import { WebappDetailProductC001UserComponent } from './webapp-detail-product-c001-user/webapp-detail-product-c001-user.component';
import { WebappSeemoreDialogC001UserComponent } from './webapp-detail-product-c001-user/webapp-seemore-dialog-c001-user/webapp-seemore-dialog-c001-user.component';
import { WebappSimilarProductsC001UserComponent } from './webapp-detail-product-c001-user/webapp-similar-products-c001-user/webapp-similar-products-c001-user.component';
import { WebappTechniqueDialogC001UserComponent } from './webapp-detail-product-c001-user/webapp-technique-dialog-c001-user/webapp-technique-dialog-c001-user.component';
import { WebappHighlightProductsC001UserComponent } from './webapp-home-fields-c001-user/webapp-highlight-products-c001-user/webapp-highlight-products-c001-user.component';
import { WebappHomeFieldsC001UserComponent } from './webapp-home-fields-c001-user/webapp-home-fields-c001-user.component';
import { WebappQuotationProductsC001UserComponent } from './webapp-home-fields-c001-user/webapp-quotation-products-c001-user/webapp-quotation-products-c001-user.component';
import { WebappProductsC001UserComponent } from './webapp-products-c001-user/webapp-products-c001-user.component';


const routes: Routes = [
  {
    path: '',
    component: WebappHomeFieldsC001UserComponent
  },
  // {
  //   path: 'san-pham',
  //   component: WebappHomeFieldsC001UserComponent
  // },
  {
    path: ':id_category/:number',
    component: WebappProductsC001UserComponent,
  },
  {
    path: ':id_category/:id_sub_category/:number',
    component: WebappProductsC001UserComponent,
  },
  {
    path: ':id_product',
    component: WebappDetailProductC001UserComponent
  }
]

@NgModule({
  declarations: [WebappHomeFieldsC001UserComponent, WebappProductsC001UserComponent,
    WebappHighlightProductsC001UserComponent,
    WebappQuotationProductsC001UserComponent, WebappTechniqueDialogC001UserComponent,
    WebappSeemoreDialogC001UserComponent, WebappSimilarProductsC001UserComponent,
    WebappCategoriesC001UserComponent, WebappDetailProductC001UserComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ComponentModule,
    CKEditorModule,
    FormsModule,
  ],
  exports: []
})
export class WebappProductsC001UserModule { }
